<template>
  <div class="page">
    <el-pagination
      :current-page="page"
      :page-size="size"
      :pager-count="5"
      :total="total"
      @current-change="changePage"
      background
      hide-on-single-page
      layout="total, prev, pager, next, jumper">
    </el-pagination>
  </div>
</template>

<script>

  export default {
    name: 'page',
    props: {
      page: { //当前页码
        type: Number,
        default: 1
      },
      size: {//每页条数
        type: Number,
        default: 10
      },
      total: {//总的条数
        type: Number,
      },
    },
    data() {
      return {}
    },
    computed: {},
    methods: {
      changePage(page) {
        this.$emit("onPage", page)
      }
    },
  }
</script>

<style lang="less" scoped>
  .page {
    height: 40px;
    margin: auto;
    text-align: center;
    color: #333333;
    margin-top: 20px;
  }

  .el-pagination {
    color: #fff;
  }

  /deep/ .el-pagination.is-background .el-pager li {
    border-radius: 25px;
    background-color: #ebf2f8;
  }

  /deep/ .el-pagination.is-background .btn-prev {
    background: none;
  }

  /deep/ .el-pagination__editor.el-input .el-input__inner {
    height: 28px;
  }

  /deep/ .el-pagination.is-background .btn-next {
    background: none;
  }

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #8c322f;
  }

  /deep/ .el-pagination.is-background .el-pager li {
    background-color: #f3eaea;
  }

</style>
